import styled from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledContentAreaColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1em;
  background-color: ${themeStyles.colors.darkGreys[4].main};
  border-radius: 8px;

  padding: 0.75em;
  margin: 2em 0 0;

  ${themeMedia.desktop`
    margin: 2em 0;
    padding: 2em;
  `}

  img, picture {
    max-width: 100%;
    height: 100%;
  }
`

export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5em;
`

export const StyledImageWrapper = styled.div`
  max-width: 80%;
  margin: 1em;

  picture {
    background: none;
  }
`
